import "../styles/globals.css";
import "@styles/globals.css";
import "react-toastify/dist/ReactToastify.css";
// import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import Footer from "@components/Footer";
import { useState, useEffect, createContext, useRef } from "react";
import AppContext from "../components/AppContext";
import { Poppins, Lexend, Inter } from "@next/font/google";
import Script from "next/script";
import Head from "next/head";
import localFont from "@next/font/local";
import { useRouter } from "next/router";
import Cookies from "../components/Cookies";
import { Analytics } from "@vercel/analytics/react";
import MixPanel from "../utils/mixpanel";
import FB, { ACTIVATE_PATHS } from "../utils/tracking/facebook";
import { clarity } from "react-microsoft-clarity";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import usePostHogCustom from "hooks/usePostHogCustom";
import { setGTMLocationData } from "@utils/tracking/trackingLocation";
import { ForgotPassword } from "components/SignatureRegister";
import CLMNavbar from "components/CLM/CLMNavbar";
import CLMFooter from "components/CLM/CLMFooter";
// import "react-tooltip/dist/react-tooltip.css";
// import "../styles/NavBar.module.css";

// const poppins = Poppins({
//   weight: ["100", "200", "300", "400", "500", "600", "700"],
//   style: ["normal", "italic"],
//   subsets: ["latin"],
// });

const lexend = Lexend({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  style: ["normal"],
  subsets: ["latin"],
  variable: "--font-lexend",
});

const inter = Inter({
  weight: ["400", "500", "600", "700"],
  style: ["normal"],
  subsets: ["latin"],
  variable: "--font-inter",
});

const biotif2 = localFont({
  src: [
    {
      path: "../assets/fonts/biotif-regular.ttf",
      weight: "400",
      style: "normal",
    },
    {
      path: "../assets/fonts/biotif-bold.ttf",
      weight: "700",
      style: "bold",
    },
    {
      path: "../assets/fonts/biotif-black.ttf",
      weight: "900",
      style: "black",
    },
    {
      path: "../assets/fonts/biotif-light.ttf",
      weight: "300",
      style: "light",
    },
  ],
});

Date.prototype.toShortFormat = function () {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = this.getDate();

  const monthIndex = this.getMonth();
  const monthName = monthNames[monthIndex];

  const year = this.getFullYear();

  return `${day} ${monthName}, ${year}`;
};

export default function App({ Component, pageProps }) {
  const [refs, setRefs] = useState({
    compareFormApprovals: null,
    comparePerFormFlow: null,
    compareAutoProctor: null,
    compareQuilgo: null,
    compareFormApprovalsPricing: null,
    comparePerFormFlowPricing: null,
    compareAutoProctorPricing: null,
    compareQuilgoPricing: null,
  });
  const { asPath, pathname, query } = useRouter();
  const [isScrolled, setIsScrolled] = useState(false);
  const [globalData, setGlobalData] = useState({
    from: "",
    utmData: {},
    modals: {
      forgotPassword: false,
    },
  });
  const [isDarkMode, setIsDarkMode] = useState(false);
  usePostHogCustom();

  const isMarginZero =
    pathname === "/features" ||
    /\/customers\/+/.test(pathname) ||
    pathname.includes("/signature/electric-signature-legality");

  const isMarginPaddingAbsoluteZero =
    pathname === "/ai" ||
    pathname === "/payment-info" ||
    pathname === "/signature/affiliates/hubspot" ||
    pathname.includes("/thank-you") ||
    pathname.includes("/super-lifetime-dealv2") ||
    pathname.includes("/signature/contracts/download-success") ||
    pathname.includes("/signature/gsuite-addon") ||
    pathname.includes("/signature/pdf-tools") ||
    pathname.includes("/signature/deals/trials") ||
    pathname.includes("/signature/deals/free-trial") ||
    pathname.includes("/super-lifetime-deal") ||
    pathname.includes("/limited-lifetime-deal") ||
    pathname.includes("/ultimate-lifetime-deal") ||
    pathname.includes("/supreme-lifetime-deal") ||
    pathname.includes("/secret-lifetime-deal") ||
    pathname.includes("/supreme-subscription-deal") ||
    pathname.includes("/ultimate-subscription-deal") ||
    pathname.includes("/mega-subscription-deal") ||
    pathname.includes("/embedding") ||
    pathname.includes("/best-esignature-apis") ||
    pathname.includes("/signature/mobile") ||
    pathname.includes("/signature/api") ||
    pathname.includes("/deals/s/st/api") ||
    pathname.includes("/deals/jvzoo") ||
    pathname.includes("/affiliate-partners") ||
    pathname.includes("/start-taking-signature") ||
    pathname.includes("/clm");

  const defaultMargin =
    // pathname === "/" ||
    pathname === "/about" ||
    pathname === "/pricing" ||
    pathname === "/signature" ||
    pathname === "/signature/pricing" ||
    pathname === "/signature/whitelabel" ||
    pathname === "/signature/api" ||
    pathname === "/signature/super-lifetime-deal" ||
    pathname === "/signature/affiliates" ||
    pathname.includes("/blog") ||
    pathname.includes("/contracts");

  const isFooterHidden =
    pathname.includes("/payment-info") ||
    pathname.includes("/deals") ||
    pathname.includes("/signature/deals/free-trial") ||
    pathname.includes("/signature/deals/trials") ||
    pathname.includes("/start-taking-signature");

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  useEffect(() => {
    new MixPanel().setupMixPanel();
    new FB();
    let isActivatePixel =
      ACTIVATE_PATHS.some((str1) => {
        // console.log(str1, url, url.includes(str1))
        return pathname.includes(str1);
      }) || pathname == "/";

    if (isActivatePixel) setGTMLocationData();
    // Start seeing data on the Clarity dashboard with your id
    clarity.init("lmtvzump4t");
  }, [pathname]);

  const isSticky = (e) => {
    const scrollTop = window.scrollY;
    scrollTop >= 389 ? setIsScrolled(true) : setIsScrolled(false);
  };
  useEffect(() => {
    setIsDarkMode(false);
  }, [pathname]);

  useEffect(() => {
    let globalDataProps = {};
    if (query?.utm_source) {
      globalDataProps.from = query.utm_source;
      // setGlobalData({ ...globalData, from: query.utm_source });
      localStorage.setItem("from", query.utm_source);
    }
    const UTM_PARAMS = [
      "utm_id",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
    ];
    let utmData = UTM_PARAMS.reduce((acc, param) => {
      if (query?.[param]) acc[param] = query?.[param];
      return acc;
    }, {});
    // console.log("utmData", utmData);
    if (Object.keys(utmData).length > 0) {
      globalDataProps.utmData = utmData;
      localStorage.setItem("utmData", JSON.stringify(utmData));
    }
    setGlobalData({ ...globalData, ...globalDataProps });
  }, [query]);

  return (
    <PostHogProvider client={posthog}>
      <AppContext.Provider value={{ globalData, setGlobalData }}>
        {/* <div className={lexend.variable}> */}
        <div
          className={`${lexend.variable} ${
            pathname.includes("/clm") ? inter.variable + " clm-wrapper" : ""
          }`}
        >
          <Head>
            <meta charSet="utf-8" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <title>BoloSign – AI Contract Management & Smart eSignatures</title>
            <meta
              name="description"
              content="BoloSign is an AI-powered contract management platform to draft, review, automate, and eSign contracts faster with built-in CLM."
            />

            <meta
              name="keywords"
              content="AI contract management, smart contract management software, contract lifecycle management CLM, AI contract drafting, contract automation platform, eSignature software, digital contract signing, legal contract automation, AI legal assistant"
            />

            <link
              rel="icon"
              href="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
            />
            <meta name="theme-color" content="#000000" />

            {/* <!-- Facebook Meta Tags --> */}
            <meta property="og:url" content="https://www.bolosign.com/" />
            <meta property="og:type" content="website" />
            <meta
              property="og:title"
              content="BoloSign – AI Contract Management & Smart eSignatures"
            />
            <meta
              property="og:description"
              content="BoloSign is an AI-powered contract management platform to draft, review, automate, and eSign contracts faster with built-in CLM."
            />
            <meta
              property="og:image"
              content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
            />

            {/* <!-- Twitter Meta Tags --> */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta property="twitter:domain" content="www.bolosign.com" />
            <meta property="twitter:url" content="https://www.bolosign.com/" />
            <meta
              name="twitter:title"
              content="BoloSign – AI Contract Management & Smart eSignatures"
            />
            <meta
              name="twitter:description"
              content="BoloSign is an AI-powered contract management platform to draft, review, automate, and eSign contracts faster with built-in CLM."
            />
            <meta
              name="twitter:image"
              content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
            />

            <link
              rel="apple-touch-icon"
              href="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
            />
            {/* <link rel="manifest" href="%PUBLIC_URL%/manifest.json" /> */}
            {/* <script
            async
            src="https://js.stripe.com/v3/pricing-table.js"
          ></script> */}
          </Head>

          <Script type="text/javascript" id="trackingDownloads">
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-W4RGM7N');`}
          </Script>

          {/* <Script type="text/javascript" id="clarity">
          {`  (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "mrp0epkzzy");`}
        </Script> */}

          <Script id="hotjar">
            {` (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:3002654,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`}
          </Script>
          {/* <!-- Google tag (gtag.js) --> */}
          <Script
            async
            src="https://www.googletagmanager.com/gtag/js?id=G-H62MLQL0XV"
          ></Script>
          <Script id="newGTag">
            {` window.dataLayer = window.dataLayer || [];

        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-H62MLQL0XV');`}
          </Script>
          <Script id="intercom1">
            {` window.intercomSettings = {
      api_base: "https://api-iam.intercom.io",
      app_id: "jldyfmwj"
    };`}
          </Script>
          <Script id="intercom2">
            {`    (function () { var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/jldyfmwj'; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } } })();`}
          </Script>
          {/* <!--Start of Tawk.to Script--> */}
          {/* <Script id="tawk" type="text/javascript"> */}
          {/* {` var Tawk_API = Tawk_API || {},
        Tawk_LoadStart = new Date();
      (function () {
        var s1 = document.createElement("script"),
          s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = "https://embed.tawk.to/625d0cfdb0d10b6f3e6e0b49/1g0tnlg9u";
        s1.charSet = "UTF-8";
        s1.setAttribute("crossorigin", "*");
        s0.parentNode.insertBefore(s1, s0);
      })();`} */}
          {/* {`(function () { var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/jldyfmwj'; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } } })();`} */}
          {/* </Script> */}
          {/* <!--End of Tawk.to Script--> */}
          {/* <!-- google translate  --> */}
          {/* <Script id="gTranslate" type="text/javascript">
          {`function googleTranslateElementInit() {
        new google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,fr,es,de,id,pt,nl,zh-CN",
          },
          "google_translate_element"
        );
      }
      setTimeout(() => {
        let skiptranslate = document.querySelector(".skiptranslate");
        skiptranslate.removeChild(skiptranslate.lastChild);
        skiptranslate.removeChild(skiptranslate.lastChild);
      }, 1000);`}
        </Script> */}
          {/* <Script
            id="gTranslateScript"
            type="text/javascript"
            src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
          ></Script> */}
          <Script
            async
            src="https://www.googletagmanager.com/gtag/js?id=G-TB2TCQPKDZ"
          ></Script>
          <Script id="">
            {` window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-TB2TCQPKDZ');`}
          </Script>
          {/* ads conversion tracking */}
          <Script
            async
            src="https://www.googletagmanager.com/gtag/js?id=AW-11249137482"
          ></Script>
          <Script id="conversiontackingid">
            {` window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'AW-11249137482');`}
          </Script>
          {/* <!-- Google Tag Manager --> */}
          {/* <!-- End Google Tag Manager --> */}
          <noscript>
            <iframe
              src="https://www.googletagmanager.com/ns.html?id=GTM-W4RGM7N"
              height="0"
              width="0"
              style={{ display: "none", visibility: "hidden" }}
            ></iframe>
          </noscript>
          {/* <!-- Google Tag Manager (noscript) --> */}
          {/* <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-W4RGM7N"
          height="0"
          width="0"
          style="display:none;visibility:hidden"
        ></iframe>
      </noscript> */}
          {/* <!-- End Google Tag Manager (noscript) --> */}
          <Script id="schema" type="application/ld+json">
            {`{
       "@context": "https://schema.org",
       "@type": "Organization",
       "name": "BoloForms",
       "url": "https://www.boloforms.com/",
       "logo": "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png",
       "contactPoint": [
           {
               "@type": "ContactPoint",
               "contactType": "customer service",
          "telephone": "+91 88306-31677",
         "email": "admin@boloforms.com",
               "areaServed": [
                   "Worldwide"
               ],
               "availableLanguage": [
                   "English"
               ]
           }
       ]
      }`}
          </Script>
          {/* <!-- Trackdesk tracker begin --> */}
          <Script async src="//cdn.trackdesk.com/tracking.js"></Script>
          <Script id="tradedesk">
            {`(function(t,d,k){(t[k]=t[k]||[]).push(d);t[d]=t[d]||t[k].f||function(){(t[d].q=t[d].q||[]).push(arguments)}})(window,"trackdesk","TrackdeskObject"); 

trackdesk('boloforms-signature', 'click');`}
          </Script>

          <Script
            id="profitwell-js"
            data-pw-auth="9e9d589a28fec9c81886cd96735a41e5"
          >
            {`(function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)};
        a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+
        s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);
        })(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');

        profitwell('start', {});`}
          </Script>

          <div
            className={`${
              // pathname === "/blog/[slug]"
              //   ? "mt-[75px]"
              //   :
              isMarginPaddingAbsoluteZero
                ? "mt-0"
                : defaultMargin
                  ? ""
                  : isMarginZero
                    ? ""
                    : "mt-0"
            } ${
              // pathname.includes("/signature/affiliates") ||
              pathname.includes("/signature/affiliate-partners") ||
              pathname.includes("/signature/electric-signature-legality") ||
              pathname === "/signature/affiliates" ||
              pathname === "/signature/whitelabel" ||
              pathname === "/signature" ||
              pathname === "/signature/api" ||
              pathname.includes("/signature/contracts/download-success") ||
              pathname.includes("/signature/gsuite-addon") ||
              pathname.includes("/signature/signature") ||
              pathname.includes("/signature/pdf-tools") ||
              pathname === "/signature/what-is-electronic-signature" ||
              pathname === "/signature/not-used-lifetime-pages/lifetime-plan" ||
              pathname ===
                "/signature/not-used-lifetime-pages/flashy-page-with-tables" ||
              pathname.includes("/lifetime-deal") ||
              pathname.includes("/super-deal") ||
              pathname.includes("/super-lifetime-deal") ||
              // pathname === "/signature/mega-subscription-deal" ||
              pathname ===
                "/not-used-lifetime-pages/signature/lifetime-offer" ||
              pathname ===
                "/not-used-lifetime-pages/signature/lifetime-deal-v2" ||
              pathname ===
                "/not-used-lifetime-pages/signature/yearly-awesome-deal" ||
              pathname ===
                "/not-used-lifetime-pages/signature/super-awesome-deal" ||
              pathname ===
                "/not-used-lifetime-pages/signature/super-yearly-awesome-deal" ||
              pathname === "/not-used-lifetime-pages/signature/new-pricing" ||
              pathname === "/calculators" ||
              pathname === "/about" ||
              pathname === "/timer-classroom" ||
              pathname === "/form-approval" ||
              pathname === "/signature/pricing" ||
              pathname.includes("/auth") ||
              pathname.includes("/blog") ||
              pathname.includes("/contracts") ||
              pathname === "/"
                ? "px-0 pt-0"
                : pathname.includes("/v2")
                  ? "px-0 pt-12"
                  : isMarginPaddingAbsoluteZero
                    ? "mt-0"
                    : ""
            } 
            `}
          >
            {!pathname.includes("/lifetime-deal") &&
              !pathname.includes("/limited-lifetime-deal") &&
              !pathname.includes("/super-lifetime-dealv2") &&
              !pathname.includes("/st/super-lifetime-deal") &&
              !pathname.includes("/supreme-lifetime-deal") &&
              !pathname.includes("/secret-lifetime-deal") &&
              !pathname.includes("/super-deal") &&
              !pathname.includes("/mega-subscription-deal") &&
              !pathname.includes("/ultimate-lifetime-deal") &&
              !pathname.includes("/ultimate-subscription-deal") &&
              !pathname.includes("/supreme-subscription-deal") &&
              !pathname.includes("/deals/s/st/api") &&
              !pathname.includes("/deals/jvzoo") &&
              !pathname.includes("/affiliate-partners") &&
              !pathname.includes("/signature/deals/free-trial") &&
              !pathname.includes("/signature/deals/trials") &&
              !pathname.includes("/start-taking-signature") &&
              // !pathname.includes("/clm") &&
              // pathname !== "/payment-info" && <NavBar refs={refs} />
              pathname !== "/payment-info" && (
                <CLMNavbar refs={refs} isDarkMode={isDarkMode} />
              )}
            {/* {pathname === "/blog/[slug]" && isScrolled && (
            <div
              style={{ background: "rgba(233, 216, 253)" }}
              className="fixed top-[75px] left-0 z-20 flex flex-col md:flex-row lg:flex-row w-full py-[5px] px-[10px] md:px-[80px] lg:px-[80px] md:py-[10px] lg:py-[10px]"
            >
              <div className="flex-grow" />
              <div
                className={`${biotif2.className} text-[14px] flex-grow text-center leading-[18px] font-semibold py-[4px] md:py-[18px] lg:py-[18px]`}
              >
                Use AI to answer all your Excel & Google Sheets related queries.
                Try SheetGod for free now.
              </div>
              <a
                href="https://sheetgod.boloforms.com"
                target="_blank"
                rel="noreferrer"
                className={`${biotif2.className} text-center  md:h-[44px] lg:h-[44px] md:w-[150px] lg:w-[150px] border-[2px] border-[#44337A] animate-blinkBorder text-[14px] leading-[18px] font-semibold my-[5px] py-[13px] px-[40px] bg-white rounded-[8px]`}
              >
                Try now!
              </a>
              <div className="flex-grow" />
            </div>
          )} */}
            <div className="pt-[112px] w-full">
              <Component
                {...pageProps}
                refs={refs}
                isDarkMode={isDarkMode}
                setIsDarkMode={setIsDarkMode}
              />
            </div>

            <Analytics />
          </div>

          <CLMFooter />
          <Cookies />

          {/* {!isFooterHidden && !pathname.includes("/clm") && <Footer />} */}
          {globalData.modals?.forgotPassword && <ForgotPassword />}
        </div>
      </AppContext.Provider>
    </PostHogProvider>
  );
}
